<aside
  class="sidebar w-52 bg-white dark:bg-gray-900 transition-all duration-300 overflow-hidden layout-sidebar shadow-md font-semibold"
  [class.w-52]="stateService.sidebarOpen()"
  [class.w-0]="!stateService.sidebarOpen()"
  [class.-translate-x-full]="!stateService.sidebarOpen()"
>
  <div class="h-full flex flex-col min-h-0">
    <div class="shrink-0">
      <div class="flex items-center py-3 border-b border-gray-200 dark:border-gray-800 px-4">
        <img src="images/logo.png" alt="Logo" class="h-10 md:h-14 flex-1 logoImage mr-4" />
        <span class="text-white font-medium text-xl tracking-tight hide logo-name">
          <span class="text-gray-900 dark:text-gray-100"> Pexlens </span>
        </span>
        <div class="absolute right-[1px]">
          <app-button
            icon="pi pi-times"
            customClass="text-gray-500 bg-transparent border-none"
            (click)="onClose()"
          ></app-button>
        </div>
      </div>
    </div>

    <div class="flex-1 min-h-0 overflow-y-auto">
      <ul class="space-y-2 px-3 py-2 overflow-auto items">
        @for (item of navItems; let index = $index; track item.route) {
          <!-- @if(!item.roles || item.roles.includes(role)) { -->
          <li>
            <a
              class="p-2 rounded-lg cursor-pointer sidebar-item flex items-center gap-3 relative nav-list nav-item dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors duration-200"
              routerLinkActive="active"
              [routerLink]="item.route"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="onNavigate()"
            >
              <!-- <app-image [name]="item.icon"></app-image> -->
              <div>
                {{ item.label }}
              </div>
            </a>
          </li>
          <!-- } -->
        }
      </ul>
    </div>
  </div>
</aside>
